import PropTypes from 'prop-types';

const ChevronRight2 = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M8.78 4.47a.75.75 0 1 0-1.06 1.06L12.19 10l-4.47 4.47-.052.056a.75.75 0 0 0 1.056 1.056l.056-.052 5-5a.75.75 0 0 0 0-1.06z"
            fill={color}
        />
    </svg>
);

export default ChevronRight2;

ChevronRight2.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
